function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AddIcon, MinusIcon } from '@domain-group/fe-co-icon';
import TextInput from '../text-input';
import * as styles from '../../styles/stepper';
import { jsx as ___EmotionJSX } from "@emotion/core";
var NUMBERS_ONLY = /^\d+$/;
var limitValue = (min, max) => value => String(Math.min(Math.max(Number(value), min), max));
export var appearances = {
  clean: 'clean',
  cleanThin: 'cleanThin',
  default: '',
  thin: 'thin',
  wide: 'wide'
};
var Stepper = _ref => {
  var appearance = _ref.appearance,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    format = _ref.format,
    groupLabel = _ref.groupLabel,
    iconsSize = _ref.iconsSize,
    id = _ref.id,
    isInvalid = _ref.isInvalid,
    max = _ref.max,
    min = _ref.min,
    name = _ref.name,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    required = _ref.required,
    step = _ref.step,
    textInputFontSize = _ref.textInputFontSize,
    textInputProps = _ref.textInputProps,
    type = _ref.type,
    valueProp = _ref.value;
  var _useState = useState(valueProp || defaultValue),
    _useState2 = _slicedToArray(_useState, 2),
    currentValue = _useState2[0],
    setValue = _useState2[1];
  var isDecrementDisabled = currentValue <= min;
  var isIncrementDisabled = currentValue >= max;
  var onLimit = limitValue(min, max);
  var onValueChange = value => {
    setValue(value);
    onChange({
      target: {
        name,
        type,
        value
      }
    });
  };
  var onValueClick = value => {
    setValue(value);
    onChange({
      target: {
        name,
        type,
        value
      }
    });
  };
  var onTextInputChange = event => {
    event.preventDefault();
    var value = event.target.value;
    if (value === '') {
      onValueChange(String(min));
      return;
    }
    if (NUMBERS_ONLY.test(value)) {
      onValueChange(onLimit(value));
    }
  };
  var onButtonClick = stepValue => event => {
    event.preventDefault();
    if (!NUMBERS_ONLY.test(currentValue)) {
      onValueClick(onLimit(min + stepValue));
      return;
    }
    var newValue = onLimit(Number(currentValue) + stepValue);
    onValueClick(newValue);
  };
  return ___EmotionJSX("div", {
    css: styles.stepper({
      appearance
    }),
    role: "group",
    "aria-label": groupLabel
  }, ___EmotionJSX("button", {
    "aria-label": "decrement",
    css: styles.actionButton,
    disabled: disabled || isDecrementDisabled,
    onClick: onButtonClick(-step),
    tabIndex: "-1",
    type: "button"
  }, ___EmotionJSX(MinusIcon, {
    size: "custom",
    css: styles.actionIcon({
      size: iconsSize,
      isDisabled: disabled || isDecrementDisabled
    })
  })), ___EmotionJSX("div", {
    css: styles.inputWrapper({
      appearance
    })
  }, ___EmotionJSX(TextInput, _extends({}, textInputProps, {
    type: type,
    css: styles.input({
      appearance,
      fontSize: textInputFontSize,
      isInvalid
    }),
    defaultValue: defaultValue,
    disabled: disabled,
    format: format,
    id: id,
    isInvalid: isInvalid,
    max: max,
    min: min,
    name: name,
    onChange: onTextInputChange,
    pattern: "\\d*",
    placeholder: placeholder,
    required: required,
    step: String(step),
    value: currentValue
  }))), ___EmotionJSX("button", {
    "aria-label": "increment",
    css: styles.actionButton,
    disabled: disabled || isIncrementDisabled,
    onClick: onButtonClick(step),
    tabIndex: "-1",
    type: "button"
  }, ___EmotionJSX(AddIcon, {
    size: "custom",
    css: styles.actionIcon({
      size: iconsSize,
      isDisabled: disabled || isIncrementDisabled
    })
  })));
};
Stepper.propTypes = {
  appearance: PropTypes.oneOf(Object.values(appearances)),
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool,
  format: PropTypes.func,
  groupLabel: PropTypes.string,
  iconsSize: PropTypes.string,
  id: PropTypes.string,
  isInvalid: PropTypes.bool,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  step: PropTypes.number,
  textInputFontSize: PropTypes.string,
  textInputProps: PropTypes.shape(TextInput.propTypes),
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
Stepper.defaultProps = {
  appearance: '',
  defaultValue: '',
  disabled: false,
  format: undefined,
  groupLabel: 'stepper',
  iconsSize: '32px',
  id: undefined,
  isInvalid: false,
  max: 100,
  min: 0,
  name: undefined,
  onChange() {},
  onClick() {},
  placeholder: '',
  required: false,
  step: 1,
  textInputFontSize: '16px',
  textInputProps: TextInput.defaultProps,
  type: 'number',
  value: ''
};
export default Stepper;